import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default class FadeInAnimation {
	constructor({ element, delay = 0 }) {
		this.element = element;
		this.delay = delay;
		this.setInitialState();
	}

	setInitialState() {
		this.tl = GSAP.timeline();
		this.tl.fromTo(
			this.element,
			{ autoAlpha: 0, y: 20 },
			{
				autoAlpha: 1,
				y: 0,
				duration: 1.6,
				ease: 'power4.out',
				delay: this.delay,
			}
		);
		this.tl.pause();
		this.tl.progress(0);
		ScrollTrigger.create({
			trigger: this.element,
			start: 'top bottom',
			onEnter: () => this.animateIn(),
			onEnterBack: () => this.animateIn(),
			onLeaveBack: () => this.animateOut(),
		});
		this.animateOut();
	}

	animateIn() {
		this.tl.play();
	}

	animateOut() {
		this.tl.reverse();
	}
}
